export const state = {
  isLoading: false,
  isOn: true,
  isFocus: false,
  modalAlertComponents: [],
  modalComponents: [],
  keywords: [],
  routeLayout: {
    isHeader: false,
    titleName: '',
    isBack: false,
    isLike: false,
    isExcel: false,
    isNav: false,
    isHome: true,
    isSearch: false,
    isGlass: false,
    isSearchHeader: false,
    isFilter: false,
    isShare: false,
    isFuneralShare: false,
    isFuneralKakaoShare: false,
    isAnnouncementShare: false,
    isAnnouncementKakaoShare: false,
    isBusinessKakaoShare: false,
    isBusinessShare: false,
    isBizDetailShare: false,
    isBusinessMarketingKakaoShare: false,
    isBusinessMarketingShare: false,
    isBusinessDonationKakaoShare: false,
    isBusinessDonationShare: false,
    isBusinessJobKakaoShare: false,
    isBusinessJobShare: false,
    isBusinessLike: false,
    isBusinessSubscribe: false,
    isMemorialShare: false,
    isMemorialKakaoShare: false,
    // Smile
    isSmileShare: false,
    isSmileKakaoShare: false,
    isInvitationShare: false,
    isInvitationKakaoShare: false,
    subName: '',
    isBell: false,
    isSetting: false,
    isFooter: false,
    isPlus: false,
    isEdit: false,
    isDelete: false,
    isGreen: false,

    isAnnouncement: false
  },
  scroll: [],
  initMovePath: '',
  keepAlive: [],
  bottomSheet: null,
  isFloating: false,
  orgNav: false, // 261012 학원·교회 회원 첫 화면(기관 템플릿) 회원이면 true — TheNav 가 홈·알림·마이 3탭으로
  parkingNav: false, // 261019 주차판 홈 회원(주차판만 있고 사장님 아님)이면 true — 같은 3탭
  memberBrowse: false, // 261020 위 회원이 '간판ON 둘러보기'로 간판ON 화면에 들어간 동안 true — TheNav 가 원래 탭바로
  isHamburger: false,
  isWellFloating: false,
  productBuyMove: false,
  loginMovePath: '',
  isBackFromSearch: false,
  isTodayExpireDate: '',
  isIntroEnter: false,
  formDirty: false,
  // 260609 리뉴얼: 메인 소비자/사업자 모드 토글 상태. localStorage 영속(마지막 선택 유지).
  // 기본 'business' — 1차 확정 시안(사업자 메인)이 디폴트. 토글로 'consumer' 전환.
  homeMode: (() => {
    try { return localStorage.getItem('homeMode') || 'business'; } catch (e) { return 'business'; }
  })()
};
export default state;
